import { FunctionComponent } from 'react';
import getConfig from 'next/config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useDetectAdBlock } from 'adblock-detect-react';

import { Routes } from 'types/routes';

import { RegisterTypes } from 'models/User';

import Button, { ButtonLayouts } from 'components/layout/Button';
import FacebookRegister from 'components/layout/FacebookRegister';
import GoogleRegister from 'components/layout/GoogleRegister';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionRegisterFirstStep: FunctionComponent<Props> = ({
    title,
    subtitle,
    buttons,
    buttonProps,
    footer,
    description,
    login,
    setPhoneForm,
    setEmailForm,
    setNextStep,
}) => {
    const isAdblock = useDetectAdBlock();
    const { publicRuntimeConfig } = getConfig();
    return (
        <StyledComponent
            className="public-page-job-section-register-first-step"
        >
            <LayoutContainer
                size={Sizes?.XMedium}
                className="content-container"
            >
                <LayoutContainer>
                    <h1
                        className="title"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <div className="cols">
                        <div className="col-left">
                            <div
                                className="subtitle"
                                dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                            <div className="button-mobile-wrapper">
                                <div className="mobile-links">
                                    <div className="links">
                                        <a
                                            href={Routes.PublicLoginWorker}
                                            className="links-page login-page"
                                        >
                                            Zaloguj się
                                        </a>
                                        <span
                                            className="links-page link-register"
                                        >
                                            Zarejestruj się
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <Button
                                onClick={() => {
                                    setPhoneForm(true);
                                    setEmailForm(false);
                                    setNextStep(true);
                                }}
                                layout={ButtonLayouts.Wide}
                                {...buttonProps}
                            >
                                {buttons?.phoneRegister?.label}
                            </Button>
                            <Button
                                onClick={() => {
                                    setEmailForm(true);
                                    setPhoneForm(false);
                                    setNextStep(true);
                                }}
                                layout={ButtonLayouts.Wide}
                                {...buttonProps}
                            >
                                {buttons?.emailRegister?.label}
                            </Button>
                            { !isAdblock && (
                                <>
                                    <FacebookRegister
                                        registerType={RegisterTypes.Facebook}
                                        onRender={(renderProps: any) => (
                                            <Button
                                                onClick={renderProps?.onClick}
                                                layout={ButtonLayouts.Wide}
                                                {...buttonProps}
                                            >
                                                {buttons?.facebookRegister?.label}
                                            </Button>
                                        )}
                                    />
                                    <GoogleOAuthProvider clientId={publicRuntimeConfig.GOOGLE_APP_ID}>
                                        <GoogleRegister
                                            registerType={RegisterTypes.Google}
                                            buttonProps={buttonProps}
                                            googleLabel={buttons?.googleRegister?.label}
                                            onRender={(renderProps: any) => (
                                                <Button
                                                    onClick={renderProps.onClick}
                                                    layout={ButtonLayouts.Wide}
                                                    {...buttonProps}
                                                >
                                                    {buttons?.googleRegister?.label}
                                                </Button>
                                            )}
                                        />
                                    </GoogleOAuthProvider>
                                </>
                            )}
                            {
                                isAdblock && (
                                    <div className="adblock-info">
                                        <p className="adblock-title">Twoja przeglądarka wykorzystuje narzędzie do blokowania reklam.</p>
                                        <p>Jeśli chcesz skorzystać z logowania lub rejestracji przez Facebook oraz Google to wyłącz narzędzie do blokowania reklam.</p>
                                    </div>
                                )
                            }

                            <div className="footer-wrapper">
                                <div
                                    className="footer"
                                    dangerouslySetInnerHTML={{ __html: footer }}
                                />
                                <Button
                                    className="btn-login"
                                    layout={ButtonLayouts.Wide}
                                    {...login}
                                >
                                    {login?.children}
                                </Button>
                            </div>
                        </div>
                        <div className="col-right">
                            <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                        </div>
                    </div>
                </LayoutContainer>
            </LayoutContainer>
        </StyledComponent>

    );
};

export default PublicPageJobSectionRegisterFirstStep;